import { useMemo } from 'react';
import { FormState } from '../types';

export const useFormValidation = (formState: FormState, isLastStep: boolean) =>
    useMemo(() => {
        const { category, types, defaultUnit, kpi } = formState;

        if (!isLastStep) {
            return !category;
        }

        if (category === 'Waste') {
            return !types || !defaultUnit;
        }

        return !kpi || !defaultUnit;
    }, [formState, isLastStep]);
